import { apiFetch } from "@/integrations/backend/client";

export type EmailTemplate = {
  id: string;
  template_id: string;
  name: string;
  sender_name: string;
  sender_email: string;
  mail_merge_terms: string[];
  content: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
};

export async function listEmailTemplates(): Promise<EmailTemplate[]> {
  const res = await apiFetch("/api/v1/admin/email-templates", { method: "GET" });
  if (!res.ok) throw new Error(`email_templates_list_failed:${res.status}`);
  return (await res.json()) as EmailTemplate[];
}

export async function createEmailTemplate(input: Omit<EmailTemplate, "id" | "created_at" | "updated_at">): Promise<EmailTemplate> {
  const res = await apiFetch("/api/v1/admin/email-templates", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`email_template_create_failed:${res.status}`);
  return (await res.json()) as EmailTemplate;
}

export async function updateEmailTemplate(id: string, patch: Partial<Omit<EmailTemplate, "id">>): Promise<void> {
  const res = await apiFetch(`/api/v1/admin/email-templates/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(`email_template_update_failed:${res.status}`);
}

export async function deleteEmailTemplate(id: string): Promise<void> {
  const res = await apiFetch(`/api/v1/admin/email-templates/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`email_template_delete_failed:${res.status}`);
}
